/* The Vital Co. — Theme JS */

(function() {
  'use strict';

  /* ── Custom Cursor ── */
  var cursor = document.getElementById('cursor');
  var ring = document.getElementById('cursor-ring');
  if (cursor && ring && window.innerWidth > 768) {
    document.addEventListener('mousemove', function(e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
      ring.style.left = e.clientX + 'px';
      ring.style.top = e.clientY + 'px';
    });
    document.addEventListener('mousedown', function() {
      cursor.style.width = '12px';
      cursor.style.height = '12px';
      ring.style.width = '24px';
      ring.style.height = '24px';
    });
    document.addEventListener('mouseup', function() {
      cursor.style.width = '7px';
      cursor.style.height = '7px';
      ring.style.width = '32px';
      ring.style.height = '32px';
    });
  } else if (cursor && ring) {
    cursor.style.display = 'none';
    ring.style.display = 'none';
    document.body.style.cursor = 'auto';
    document.querySelectorAll('a, button').forEach(function(el) { el.style.cursor = 'auto'; });
  }

  /* ── Mobile Nav Toggle ── */
  const navToggle = document.getElementById('nav-toggle');
  const navLinks = document.getElementById('nav-links');

  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      navLinks.classList.toggle('active');
    });

    // Close menu on link click
    navLinks.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        navLinks.classList.remove('active');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── Testimonial Rotation ── */
  const slides = document.querySelectorAll('.testimonial-slide');
  if (slides.length > 1) {
    let current = 0;
    setInterval(function() {
      slides[current].style.display = 'none';
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].style.display = 'block';
      slides[current].classList.add('active');
    }, 6000);
  }

  /* ── Smooth Scroll for Anchor Links ── */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Intersection Observer for Fade-in ── */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .article-card, .trust-item').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }
})();
